import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldAlertBeDisplayed)?_c(VCol,{attrs:{"cols":"12"}},[_c(VAlert,{staticClass:"my-4",attrs:{"value":_vm.shouldAlertBeDisplayed,"prominent":"","outlined":"","type":"warning","icon":"access_time"}},[_vm._v(" "+_vm._s(_vm.$t('timer.reminder'))+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }